import { useState, useEffect } from 'react'

import { useModals } from 'almanac-ui/Modal'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import {
  BrandVoicePaywallModal,
  CREATOR_BRAND_VOICE_LIMIT,
} from 'components/BrandVoicePaywallModal/BrandVoicePaywallModal'
import { useBrandVoices } from 'hooks/useBrandVoices'
import { useCurrentPlan } from 'hooks/useCurrentPlan'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { usePaymentPlans } from 'hooks/usePaymentPlans'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { WorkspaceClient } from 'api/clients/WorkspaceClient'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { BillingFrequency } from 'components/Paywall/UpgradePlanModal/UpgradePlanModal'

export const useBrandVoicePaywall = () => {
  const currentWorkspace = useCurrentWorkspace()
  const { data: voices } = useBrandVoices(currentWorkspace)
  const { data: currentPlan, isFetched } = useCurrentPlan()
  const { openModal } = useModals()
  const [showBrandVoicePaywall, setShowBrandVoicePaywall] = useState(false)
  const { paymentPlans } = usePaymentPlans()

  const onUpgrade = async () => {
    const teamPlan = paymentPlans.find((p) => p.key === PaymentPlanKey.BlazeTeam)
    const billingFrequency = currentPlan?.billing_frequency as BillingFrequency

    if (!currentWorkspace || !teamPlan || !billingFrequency) {
      showErrorMessageToast('Unabled to upgrade. Try again.')
      return
    }

    const priceId = teamPlan.price[billingFrequency].price_id

    const {
      data: { success },
    } = await WorkspaceClient.updateSubscription(currentWorkspace.id, priceId)

    if (success) {
      showToastMessage('You are now on the Team plan!')
      setShowBrandVoicePaywall(false)
      return
    }

    showErrorMessageToast('Unable to upgrade subscription. Try again.')
  }

  useEffect(() => {
    if (!isFetched || !currentPlan) return

    const onCreatorPlan = currentPlan.plan === PaymentPlanKey.BlazeCreator
    const reachedCreatorLimit = onCreatorPlan && (voices?.length || 0) >= CREATOR_BRAND_VOICE_LIMIT
    setShowBrandVoicePaywall(reachedCreatorLimit)
  }, [isFetched, currentPlan, voices?.length])

  const openBrandVoicePaywall = () => {
    openModal(BrandVoicePaywallModal, {
      onUpgrade,
    })
  }

  return {
    showBrandVoicePaywall,
    openBrandVoicePaywall,
    onUpgrade,
  }
}
